var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYec(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 137.391,
    height: 14.5,
    viewBox: "0 0 137.391 14.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_41",
    "data-name": "Raggruppa 41",
    transform: "translate(-380.127 -171.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_128",
    "data-name": "Tracciato 128",
    d: "M390.761,178.319h2.477v5.619a7.871,7.871,0,0,1-2.538,1.329,9.725,9.725,0,0,1-2.981.463,8.041,8.041,0,0,1-3.887-.936,6.957,6.957,0,0,1-2.719-2.588,7.528,7.528,0,0,1,0-7.452,6.943,6.943,0,0,1,2.729-2.588,8.139,8.139,0,0,1,3.917-.937,8.549,8.549,0,0,1,3.222.584,6.331,6.331,0,0,1,2.437,1.712l-1.651,1.611a5.3,5.3,0,0,0-3.887-1.611,5.494,5.494,0,0,0-2.648.625,4.549,4.549,0,0,0-1.812,1.752,5.039,5.039,0,0,0-.655,2.578,4.959,4.959,0,0,0,.655,2.538,4.694,4.694,0,0,0,1.812,1.773,5.314,5.314,0,0,0,2.628.644,5.672,5.672,0,0,0,2.9-.725Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_129",
    "data-name": "Tracciato 129",
    d: "M461.134,186.2l-2.88-4.129a5.251,5.251,0,0,1-.544.02h-3.182V186.2H451.91V172.1h5.8a7.808,7.808,0,0,1,3.192.6,4.643,4.643,0,0,1,2.084,1.732,4.848,4.848,0,0,1,.725,2.679,4.78,4.78,0,0,1-.775,2.739,4.613,4.613,0,0,1-2.225,1.712l3.242,4.632Zm-.947-11.157a4.022,4.022,0,0,0-2.6-.725h-3.061v5.619h3.061a3.979,3.979,0,0,0,2.6-.735,2.556,2.556,0,0,0,.886-2.084A2.527,2.527,0,0,0,460.187,175.044Z",
    transform: "translate(-55.228 -0.672)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_130",
    "data-name": "Tracciato 130",
    d: "M516.852,184.762a6.387,6.387,0,0,1-1.631-4.7V172.1h2.618v7.855q0,4.149,3.585,4.148,3.565,0,3.565-4.148V172.1h2.578v7.955a6.411,6.411,0,0,1-1.621,4.7,7.118,7.118,0,0,1-9.093,0Z",
    transform: "translate(-103.939 -0.672)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_131",
    "data-name": "Tracciato 131",
    d: "M593.637,172.708a4.643,4.643,0,0,1,2.084,1.732,5.292,5.292,0,0,1,0,5.348,4.619,4.619,0,0,1-2.084,1.742,7.8,7.8,0,0,1-3.192.6h-3.182V186.2h-2.618V172.1h5.8A7.806,7.806,0,0,1,593.637,172.708Zm-.715,6.485a2.871,2.871,0,0,0,0-4.149,4.022,4.022,0,0,0-2.6-.725h-3.061v5.6h3.061A4.023,4.023,0,0,0,592.922,179.193Z",
    transform: "translate(-157.352 -0.672)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_132",
    "data-name": "Tracciato 132",
    d: "M656.165,172.708a4.644,4.644,0,0,1,2.084,1.732,5.294,5.294,0,0,1,0,5.348,4.62,4.62,0,0,1-2.084,1.742,7.8,7.8,0,0,1-3.192.6H649.79V186.2h-2.618V172.1h5.8A7.808,7.808,0,0,1,656.165,172.708Zm-.715,6.485a2.871,2.871,0,0,0,0-4.149,4.022,4.022,0,0,0-2.6-.725H649.79v5.6h3.061A4.023,4.023,0,0,0,655.449,179.193Z",
    transform: "translate(-205.459 -0.672)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_133",
    "data-name": "Tracciato 133",
    d: "M709.912,184.794a6.934,6.934,0,0,1-2.719-2.6,7.489,7.489,0,0,1,0-7.431,6.935,6.935,0,0,1,2.719-2.6,8.535,8.535,0,0,1,7.774,0,6.962,6.962,0,0,1,2.719,2.588,7.527,7.527,0,0,1,0,7.452,6.959,6.959,0,0,1-2.719,2.588,8.536,8.536,0,0,1-7.774,0Zm6.425-1.994a4.588,4.588,0,0,0,1.772-1.772,5.357,5.357,0,0,0,0-5.1,4.59,4.59,0,0,0-1.772-1.772,5.393,5.393,0,0,0-5.075,0,4.587,4.587,0,0,0-1.772,1.772,5.358,5.358,0,0,0,0,5.1,4.586,4.586,0,0,0,1.772,1.772,5.393,5.393,0,0,0,5.075,0Z",
    transform: "translate(-250.879 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_134",
    "data-name": "Tracciato 134",
    d: "M807.364,181.227V186.2h-2.618v-4.934l-5.539-9.164h2.8l4.129,6.868L810.3,172.1h2.578Z",
    transform: "translate(-322.432 -0.672)",
    fill: "#5887da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_135",
    "data-name": "Tracciato 135",
    d: "M875.626,184.007v2.2H865.053V172.1h10.291v2.2h-7.673v3.665h6.807v2.155h-6.807v3.887Z",
    transform: "translate(-373.092 -0.672)",
    fill: "#5887da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_136",
    "data-name": "Tracciato 136",
    d: "M922.611,184.794a6.905,6.905,0,0,1-2.7-2.588,7.561,7.561,0,0,1,.01-7.452,6.978,6.978,0,0,1,2.709-2.588,7.94,7.94,0,0,1,3.857-.937,8.039,8.039,0,0,1,3.162.6,6.447,6.447,0,0,1,2.417,1.752l-1.692,1.591a4.935,4.935,0,0,0-3.766-1.651,5.28,5.28,0,0,0-2.6.634,4.569,4.569,0,0,0-1.793,1.762,5.4,5.4,0,0,0,0,5.116,4.569,4.569,0,0,0,1.793,1.762,5.279,5.279,0,0,0,2.6.634,4.905,4.905,0,0,0,3.766-1.672l1.692,1.611a6.434,6.434,0,0,1-2.427,1.752,8.118,8.118,0,0,1-3.172.6A7.941,7.941,0,0,1,922.611,184.794Z",
    transform: "translate(-414.548 0)",
    fill: "#5887da"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYec);
export default __webpack_public_path__ + "static/media/yec.ed7056bb933d5db24345a1d05c01f69d.svg";
export { ForwardRef as ReactComponent };